/**
 * Serializa el estado de la ficha (objetos { valor, error }) a un JSON plano para el backend.
 */
export const serializarEstadoFicha = (formState) => {
    if (!formState || typeof formState !== 'object') return {};
    const out = {};
    Object.keys(formState).forEach((key) => {
        const v = formState[key];
        if (v !== null && typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, 'valor')) {
            out[key] = v.valor;
        } else if (key === 'sesiones' && Array.isArray(v)) {
            out[key] = v;
        }
    });
    return out;
};

export const CLAVES_RENOMBRADAS = {
    // ficha cognitiva (bien_apr)
    detalle_antecedentes_psiquiatricos: 'detalle_terapia_neuropsicologia',
    aspectos_relevantes_anotaciones: 'aspectos_revelantes_anotaciones',
    // ficha comunicativa (bien_com)
    ocupacion_familiar: 'ocupacion_familia',
    hab_leer: 'habcom_leer',
    hab_escribir: 'habcom_escribir',
    hab_escuchar: 'habcom_escuchar',
    hab_hablar: 'habcom_hablar',
};

const sinValor = (v) => v === undefined || v === null || v === '';

/**
 * Copia el valor de las claves viejas sobre las nuevas. Lo guardado con el
 * nombre nuevo siempre gana: el alias solo rellena lo que venga vacio.
 */
const aplicarClavesRenombradas = (datos) => {
    const out = { ...datos };
    Object.keys(CLAVES_RENOMBRADAS).forEach((viejo) => {
        const nuevo = CLAVES_RENOMBRADAS[viejo];
        if (Object.prototype.hasOwnProperty.call(out, viejo) && sinValor(out[nuevo])) {
            out[nuevo] = out[viejo];
        }
    });
    return out;
};

/**
 * Fusiona datos guardados en el servidor sobre el estado base del formulario.
 */
export const mergeDatosGuardadosEnEstado = (estadoBase, datos = {}) => {
    if (!estadoBase || typeof estadoBase !== 'object') return estadoBase;
    const next = { ...estadoBase };
    const datosNormalizados = aplicarClavesRenombradas(datos);
    Object.keys(datosNormalizados).forEach((key) => {
        if (key === 'sesiones' && Array.isArray(datosNormalizados[key])) {
            next[key] = datosNormalizados[key];
            return;
        }
        const slot = next[key];
        if (slot && typeof slot === 'object' && Object.prototype.hasOwnProperty.call(slot, 'valor')) {
            next[key] = {
                ...slot,
                valor: datosNormalizados[key] !== undefined && datosNormalizados[key] !== null ? datosNormalizados[key] : slot.valor,
                error: '',
            };
        }
    });
    return next;
};
